import { Component, OnInit } from '@angular/core';
import { DivisionService } from '../../../services/division/division.service';
import { DataTableService } from '../../../modules/UIKit/components/dataTable/dataTable.service';
import { Division } from '../../../models/division.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-division',
  templateUrl: './division.component.html',
  styleUrls: ['./division.component.css']
})

export class DivisionComponent implements OnInit {

  selectedDivision: Division = null;
  divisions: any[];
  newDataAvailable = false;
  modalTitle = '';
  labels = {}

  constructor (
    public srvDivision: DivisionService,
    private srvDataTable: DataTableService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.divisions = [];

    this.translate.get([
      'divisionList.add_title',
      'divisionList.edit_title'
    ]).subscribe((res) => {
      this.labels['add_title'] = res['divisionList.add_title'];
      this.labels['edit_title'] = res['divisionList.edit_title'];
    });

    this.srvDivision.getAll().subscribe(res => {
      this.divisions = res;
    });
  }

  refresh() {
    this.srvDivision.getAll().subscribe(res => {
      this.divisions = res;
      this.newDataAvailable = true;
    });
  }

  showAddOrEditDialog(data): void {
    this.modalTitle = data == null ? this.labels['add_title'] : this.labels['edit_title'];
    this.srvDivision.divisionEditing = data == null ? new Division() : data;
  }

  delete (record): void {
    this.srvDivision.delete(record).subscribe( () => {
      this.refresh ();
    });
  }

  divisionAdded($event): void {
    this.srvDivision.post($event).subscribe(() => {
      this.srvDataTable.get('dt_division').showDetail = false;
      this.newDataAvailable = true;
      this.srvDivision.divisionEditing = null;
    });

  }

  divisionUpdated($event): void {
    this.srvDivision.put($event).subscribe(() => {
      this.srvDataTable.get('dt_division').showDetail = false;
      this.newDataAvailable = true;
      this.srvDivision.divisionEditing = null;
    });
  }

  closeAddDialog () {
    this.newDataAvailable = true;
    this.srvDivision.divisionEditing = null;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/division/division.component.ts